import { render, staticRenderFns } from "./CanaisAtendimento.vue?vue&type=template&id=25b21066"
import script from "./CanaisAtendimento.vue?vue&type=script&lang=js"
export * from "./CanaisAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports